import { useEffect, useState } from "react";
import API_BASE_URL from '../../api/config';

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

const AlumniEvents = () => {
  useScrollToTop();
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/alumni_ethiccraft/read_isShown`)
      .then((res) => res.json())
      .then((data) => {
        const arr = Array.isArray(data) ? data : (data.data || []);
        if (Array.isArray(arr) && arr.length > 0) {
          setImageUrl(arr[0].image);
        } else {
          setImageUrl(null);
        }
      })
      .catch((error) => {
        console.error("Error fetching alumni event image:", error);
      });
  }, []);

  return (
    <section className="alumni-events">
      <div className="alumni-content">
        <h2 className="alumnievents-title">Ethiccraft Alumni Connect</h2>
        <p className="alumni-description">
          <h1>From Campus Roots to Lifelong Impact</h1>
          <br />
          Valumni (Values + Alumni) is Ethiccraft’s alumni community, where graduates stay connected and continue living the values they embraced on campus. It’s a lifelong network for leadership, impact, and meaningful connections beyond graduation.
        </p>
      </div>
      <div className="alumni-image-container">
        {imageUrl ? (
          <img src={`https://ethiccraft.org/${imageUrl}`} className="alumni-image" alt='Valumni' />
        ) : (
          <p>.</p>
        )}
      </div>
    </section>
  );
};

export default AlumniEvents;